// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-QuestionList-HotCourse-container-hY5wT","courses":"src-components-QuestionList-HotCourse-courses-PLaIE","title":"src-components-QuestionList-HotCourse-title-14zAj","row":"src-components-QuestionList-HotCourse-row-B3Jnj","detail":"src-components-QuestionList-HotCourse-detail-2Enao","more":"src-components-QuestionList-HotCourse-more-2Ohcg","examInfo":"src-components-QuestionList-HotCourse-examInfo-CeAH0","button":"src-components-QuestionList-HotCourse-button-weByK","picture":"src-components-QuestionList-HotCourse-picture-24vOz","detailCenter":"src-components-QuestionList-HotCourse-detailCenter-3zsic"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/QuestionList/HotCourse.css
 ** module id = 276
 ** module chunks = 0
 **/